import React from "react";
import { Button, Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import PleaseShowThis from "../images/Haleon/PleaseShowThis_sg.png"
import TncText from "../images/Haleon/TncText_sg.png"

const GuardianOffModal = ({ isShow, onClose }) => {

	return (
		<div>
			<Modal
					open={isShow}
					centered
					footer={null}
					width={300}
					onCancel={onClose}
					style={{
						zIndex: "2",
					}}
					closeIcon={<CloseOutlined />}
				>
					<div className="text-center">
						<div className="mt-3"></div>
						<div style={{ height: "65vh", overflowY: "auto", overflowX: "hidden" }}>
							<div
								style={{
									display: "flex",
									padding: "8px 0px",
									flexDirection: "column",
									justifyContent: "center",
									alignItems: "center",
									gap: "20px",
									lineHeight: "15px",
								}}
							>
								
                                <img src={PleaseShowThis} style={{ width: "100%" }}></img>
                                
                                <img src={TncText} style={{ width: "100%" }}></img>
							</div>
							
						</div>
                        <Button 
                            type="text"
                            onClick={onClose}
                            alt=""
                            style={{
                                backgroundColor: '#CB0E07',
                                position: 'relative',
                                width: "100%",
                                placeItems: "center"
                            }}
                        >
                            <p style={{ color: "white" }}>Close</p>
                        </Button>
					</div>
				</Modal>
		</div>
	);
};

export default GuardianOffModal;
